import { http } from 'vue'
let r1 = false
let r2 = false
let resource = 'products'
export default {
  loadProducts (context, params = {}) {
    let companyId = (params.companyId) ? '&company_id=' + params.companyId : ''
    return http.get(resource + '?sort=name&category_id=1' + companyId, {
      before (request) {
        if (r1) r1.abort()
        r1 = request
      }
    })
  },
  loadProduct (context, params = {}) {
    return http.get(resource + '/' + params.productId, {
      before (request) {
        if (r2) r2.abort()
        r2 = request
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/products/actions.js